import { Controller } from "@hotwired/stimulus"

// Hoja "¿Cómo se ve X?" (<dialog>): Automático / Carta / Catálogo son submits de un form PATCH que se
// apunta a la fila; el servidor reemplaza la fila por stream (422 como toast).
// Doc: _docs/frontend/catalog_presentation/partner_sections.md → Cliente
export default class extends Controller {
  static targets = ["dialog", "name", "summary", "form", "option", "store"]

  connect() {
    // No cachear la hoja abierta (el snapshot se toma antes del disconnect)
    this.beforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  // section-row:layout / section-sheet:layout: la fila trae nombre, conteo, URL y la vista elegida ("" = automático)
  open(event) {
    const { sectionName, sectionSummary, sectionUrl, sectionLayout, sectionId } = event.detail.row.dataset
    this.nameTarget.textContent = sectionName
    this.summaryTarget.textContent = sectionSummary
    this.formTarget.action = sectionUrl
    this.optionTargets.forEach(option => option.setAttribute("aria-pressed", String(option.value === (sectionLayout || ""))))
    this.storeTarget.href = `${this.storeTarget.href.split("#")[0]}#section-${sectionId}`
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // Click en el ::backdrop llega al propio <dialog>
  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // turbo:submit-end: con éxito la fila ya cambió; con 422 el aviso es un toast
  submitted() {
    this.close()
  }
}
